import { dispatcher } from '../../../../core/actions';

const DEFAULT_REVIEW_MESSAGE =
  ':name:, would you be willing to take 30 seconds to leave us a review using the link below? Let me know how I can help in the future. :review:';

export const getDefaultWelcomeMessage = (merchantName) => {
  const from = merchantName ? ` from ${merchantName}` : '';
  return `Hello :name:, this is :associate:${from}. I look forward to personally assisting you. Anything you need is just a text away.`;
};

export const messageDispatcher = data => {
  let DEFAULT_STORE = '';
  let REVIEW_MESSAGE = '';
  let REVIEW_IMAGES_URL = [];
  let WELCOME_MESSAGE = '';
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      let textVal = '';
      if (key.toUpperCase() === 'DEFAULT_STORE') {
        DEFAULT_STORE = data[key];
      }
      if (key.toUpperCase() === 'REVIEW_MESSAGE') {
        REVIEW_MESSAGE = data[key];
      }
      if (key.toUpperCase() === 'REVIEW_IMAGES_URL') {
        REVIEW_IMAGES_URL = data[key];
      }
      if (key.toUpperCase() === 'WELCOME_MESSAGE') {
        WELCOME_MESSAGE = data[key];
      }
      if (data[key] !== null) textVal = data[key];
      dispatcher(`SET_MSG_${key.toUpperCase()}`, textVal);
    }
  }
  if (!REVIEW_MESSAGE) {
    dispatcher('SET_MSG_REVIEW_MESSAGE', DEFAULT_REVIEW_MESSAGE);
  }
  if (!REVIEW_IMAGES_URL) {
    dispatcher('SET_MSG_REVIEW_IMAGES_URL', []);
  }
  if (!DEFAULT_STORE) {
    dispatcher('SET_MSG_DEFAULT_STORE', '');
  }
  if (!WELCOME_MESSAGE) {
    dispatcher('SET_MSG_WELCOME_MESSAGE', getDefaultWelcomeMessage(data.brandName || ''));
  }
};

export const bodyFormatter = props => {
  let {
    autoAsA2p,
    setSchTime,
    defaultStore,
    reviewMessage,
    reviewImages,
    sendWelcomeMessage,
    welcomeMessage,
    allStoreConversationHistory,
    autoCloseTime,
    merchantConfig: { DECLUTTERED_INBOX },
  } = props;

  if (reviewMessage === DEFAULT_REVIEW_MESSAGE) {
    reviewMessage = null;
  }

  if (!welcomeMessage || !welcomeMessage.trim()) {
    welcomeMessage = getDefaultWelcomeMessage(props.brandName || '');
  } else if (welcomeMessage.length > 255) {
    welcomeMessage = welcomeMessage.substring(0, 255);
  }

  return {
    AUTO_AS_A2P: autoAsA2p,
    AUTO_MSG_TIME: setSchTime,
    DEFAULT_STORE: defaultStore,
    REVIEW_MESSAGE: reviewMessage,
    REVIEW_IMAGES_URL: reviewImages,
    SEND_WELCOME_MESSAGE: sendWelcomeMessage,
    WELCOME_MESSAGE: welcomeMessage,
    ALL_STORE_CONVERSATION_HISTORY: allStoreConversationHistory,
    DECLUTTERED_INBOX,
    AUTO_CLOSE_MIN_DAYS: autoCloseTime,
  };
};

export const bodyFormatterKiosk = props => {
  const {
    logoUrl,
    roundLogo,
    backgroundColor,
    primaryColor,
    secondaryColor,
    backgroundLabelColor,
    backgroundUrl,
    introTitle,
    formTitle,
    topSectionHeader,
    bottomSectionHeader,
    optInTitle,
    optInHelp,
    optInLegal,
    buttonText,
    completeTitle,
    completeSubtitle,
    show_anniversary,
    show_birthday,
    show_address,
    show_email,
  } = props;

  return {
    logo_url: logoUrl,
    round_logo: roundLogo,
    background_color: backgroundColor,
    primary_color: primaryColor,
    secondary_color: secondaryColor,
    background_label_color: backgroundLabelColor,
    background_url: backgroundUrl,
    intro_title: introTitle,
    form_title: formTitle,
    top_section_header: topSectionHeader,
    bottom_section_header: bottomSectionHeader,
    opt_in_title: optInTitle,
    opt_in_help: optInHelp,
    opt_in_legal: optInLegal,
    button_text: buttonText,
    complete_title: completeTitle,
    complete_subtitle: completeSubtitle,
    show_anniversary,
    show_birthday,
    show_address,
    show_email,
  };
};

export const bodyFormatterApp = props => {
  const {
    appBulkLimit,
    dailyContactGoal,
    salesOppName,
    merchantConfig: { LIMIT_ASSOCIATE_VISIBILITY_ENABLED, HIDE_PRODUCT_COST },
    merchantFlags,
  } = props;

  const LIMITED_ASSOCIATE_VISIBILITY = merchantFlags?.limited_associate_visibility?.enabled;

  return {
    APP_BULK_LIMIT: appBulkLimit,
    daily_contact_goal: dailyContactGoal,
    SALES_OPP_NAME: salesOppName,
    LIMIT_ASSOCIATE_VISIBILITY_ENABLED,
    LIMITED_ASSOCIATE_VISIBILITY,
    HIDE_PRODUCT_COST,
  };
};
